import axiosInstance from "core/api/axiosInstance";
import { userConcessions } from "../model/userConcession";
import { getRole } from "modules/rol/services/rolService";

export const getAllUsersService = async () => {
  try {
    const { data } = await axiosInstance.get("/api/users/all");
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener usuarios");
  }
};

// Nueva función para obtener usuarios con nombres de roles
export const getUsersWithRolesService = async () => {
  try {
    // Obtener usuarios y roles en paralelo
    const [usersResponse, rolesResponse] = await Promise.all([
      axiosInstance.get("/api/users/all"),
      getRole(),
    ]);

    const users =
      typeof usersResponse.data === "string" ? JSON.parse(usersResponse.data) : usersResponse.data;

    const roles = Array.isArray(rolesResponse) ? rolesResponse : [];

    // Mapear usuarios con el nombre del rol
    const usersWithRoles = users.map((user) => ({
      ...user,
      role: roles.find((r) => r.id === user.roleId) || { name: "Sin rol", id: user.roleId },
    }));

    return usersWithRoles;
  } catch (error) {
    console.error("Error al obtener usuarios con roles:", error);
    throw error;
  }
};

export const updateUserService = async (id, userData) => {
  try {
    const { data } = await axiosInstance.put(`/api/users/${id}`, userData);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al actualizar usuario");
  }
};

export const createUserService = async (userData) => {
  try {
    const { data } = await axiosInstance.post("/api/users", userData);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al crear usuario");
  }
};

export const putUserService = async (userId) => {
  try {
    const { data } = await axiosInstance.delete(`/api/users/${userId}`);
    return data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Error al eliminar el usuario";
    throw new Error(errorMessage);
  }
};

export const changePasswordService = async (userId, newPassword) => {
  try {
    const { data } = await axiosInstance.post("/api/users/change-password", {
      id: userId,
      newpassword: newPassword,
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al cambiar la contraseña");
  }
};

export const getUserConcessionsService = async ({ signal } = {}) => {
  const { data } = await axiosInstance.get("/api/commerce/get-all", { signal });
  return userConcessions(data);
};
